import { DropDownList } from '@syncfusion/ej2-dropdowns';

import { routes } from '@/shared/routes';
import { CustomFieldSettings } from '@/shared/types/customFields';
import { FormFieldType } from '@/shared/types/enum';

import { getControl } from '@/front/editable/state';
import { listen } from '@/front/event';
import { GET } from '@/front/fetch';

listen('editablesReady', () => {
  [...document.querySelectorAll('form#customFields .editable[data-field$="Type"]')]
    .map((editableElement) => editableElement as HTMLDivElement)
    .forEach((editableElement) => {
      const td = editableElement.closest('td') as HTMLTableCellElement;

      const tr = editableElement.closest('tr') as HTMLTableRowElement;

      const dropDownList = getControl(editableElement.id) as DropDownList | undefined;

      if (dropDownList) {
        const refresh = (type: FormFieldType) => {
          const selected = dropDownList.value === type;
          const typeDiv = td.querySelector(`div[data-custom-field-type="${type}"]`) as HTMLDivElement | null;
          typeDiv?.classList.toggle('d-none', !selected);
          const rowDiv = tr.querySelector(`div[data-custom-field-type="${type}"]`) as HTMLDivElement | null;
          rowDiv?.classList.toggle('d-none', !selected);
        };

        refresh(FormFieldType.Dropdown);
        refresh(FormFieldType.Number);

        dropDownList.addEventListener('change', () => {
          refresh(FormFieldType.Dropdown);
          refresh(FormFieldType.Number);
        });
      }
    });
});

export const getCustomFieldSettings = async (): Promise<CustomFieldSettings> => {
  const res = await GET(routes.data.customFields());
  return (await res.json()) as CustomFieldSettings;
};
